import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import styles from './checkbox.module.scss';

interface CheckboxProps {
	checked?: boolean;
	indeterminate?: boolean;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	className?: string;
	id?: string;
	disabled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
	checked = false,
	indeterminate = false,
	onChange,
	className,
	id = 'checkbox-' + Math.random().toString(36).substring(2, 9),
	disabled,
}) => {
	const ref = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (ref.current) {
			ref.current.indeterminate = indeterminate;
		}
	}, [indeterminate]);

	return (
		<div className={clsx('flex items-center justify-center', className)}>
			<input
				ref={ref}
				type="checkbox"
				id={id}
				className={clsx(styles.checkbox)}
				checked={checked}
				onChange={onChange}
				disabled={disabled}
			/>
			<label htmlFor={id}></label>
		</div>
	);
};
